import { EMPTY_LIST } from '../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'

export const FLAT_FORM_FIELD_NAME_BUILDING = 'building'

export const FLAT_FORM_FIELD_NAME_CONTRACT_ID = 'contract_id'

export const FLAT_FORM_FIELD_NAME_CONTRACTS = 'contracts'

export const FLAT_FORM_FIELD_NAME_FILES = 'files'

export const FLAT_FORM_FIELD_NAME_FLOOR_NUMBER = 'floor'

export const FLAT_FORM_FIELD_NAME_ENTRANCE = 'entrance'

export const FLAT_FORM_FIELD_NAME_ENTRANCE_ADDRESS = 'entrance_address'

export const FLAT_FORM_FIELD_NAME_INHABITANT = 'inhabitant'

export const FLAT_FORM_FIELD_NAME_NOTES = 'notes'

export const FLAT_FORM_FIELD_NAME_FLAT_NUMBER = 'number'

export const FLAT_FORM_FIELD_NAME_PROPERTY_SHARE = 'property_share'

export const FLAT_FORM_FIELD_NAME_PURCHASE_CONTRACT_NUMBER =
  'purchase_contract_number'

export const FLAT_FORM_FIELD_NAME_ROOM_TYPE = 'room_type'

export const FLAT_FORM_FIELD_NAME_SHARE = 'share'

export const FLAT_FORM_FIELD_NAME_CONTRACT_START_DATE = 'start_date'

export const FLAT_FORM_FIELD_NAME_TOTAL = 'total'

export const FLAT_FORM_CONTRACT_ID_FIELD_MAX_LENGTH = 255

export const FLAT_FORM_SECOND_CONTRACT_ID_FIELD_MAX_LENGTH = 255

export const FLAT_FORM_FLAT_NUMBER_FIELD_MAX_LENGTH = 255

export const FLAT_FORM_FLOOR_NUMBER_FIELD_MAX_LENGTH = 64

export const FLAT_FORM_ENTRANCE_ADDRESS_FIELD_MAX_LENGTH = 256

export const FLAT_FORM_ENTRANCE_FIELD_MAX_LENGTH = 64

export const FLAT_FORM_NOTES_FIELD_MAX_LENGTH = 2000

export const FLAT_FORM_SHARE_FIELD_PRECISION = 3

export const FLAT_FORM_TOTAL_FIELD_MAX_VALUE = 1000000000

export const FLAT_FORM_INITIAL_VALUES = {
  [FLAT_FORM_FIELD_NAME_BUILDING]: null,
  [FLAT_FORM_FIELD_NAME_CONTRACTS]: EMPTY_LIST,
  [FLAT_FORM_FIELD_NAME_ENTRANCE]: FORMIK_EMPTY_VALUE,
  [FLAT_FORM_FIELD_NAME_ENTRANCE_ADDRESS]: FORMIK_EMPTY_VALUE,
  [FLAT_FORM_FIELD_NAME_FLAT_NUMBER]: FORMIK_EMPTY_VALUE,
  [FLAT_FORM_FIELD_NAME_FLOOR_NUMBER]: FORMIK_EMPTY_VALUE,
  [FLAT_FORM_FIELD_NAME_NOTES]: FORMIK_EMPTY_VALUE,
  [FLAT_FORM_FIELD_NAME_ROOM_TYPE]: null,
  [FLAT_FORM_FIELD_NAME_SHARE]: FORMIK_EMPTY_VALUE,
  [FLAT_FORM_FIELD_NAME_TOTAL]: FORMIK_EMPTY_VALUE,
}

export const FLAT_FORM_INHABITANT_INITIAL_VALUES = {
  [FLAT_FORM_FIELD_NAME_CONTRACT_ID]: FORMIK_EMPTY_VALUE,
  [FLAT_FORM_FIELD_NAME_CONTRACT_START_DATE]: null,
  [FLAT_FORM_FIELD_NAME_INHABITANT]: null,
  [FLAT_FORM_FIELD_NAME_PURCHASE_CONTRACT_NUMBER]: FORMIK_EMPTY_VALUE,
}
